(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('userAccount', function (ModalService, $rootScope, SplashModalService, $firebaseObject) {

		return {
			scope: {
				status: '@',
				data: '='
			},
			templateUrl: 'directives/account/table.html',
			controller: function($scope) {
				var url = 'https://breakmark.firebaseio.com';
				var fireRef = new Firebase(url);
				$scope.user = fireRef.getAuth();
				$scope.password = {
					currentPassword: '',
					newPassword: ''
				};

				$scope.errorMessage = '';
				$scope.successMessage = '';

				$scope.changePassword = function() {
					$scope.errorMessage = '';
					$scope.successMessage = '';

					fireRef.changePassword({
						  email: $scope.user.password.email,
						  oldPassword: $scope.password.old,
						  newPassword: $scope.password.new
					}, function(error) {
					  if (error) {
						    $scope.errorMessage = '';
							switch (error.code) {
							  case "INVALID_PASSWORD":
							    	console.log("The specified user account password is incorrect.");
									$scope.errorMessage = 'Invalid password';
							    	break;
							  case "INVALID_USER":
							    	console.log("The specified user account does not exist.");
									$scope.errorMessage = 'Invalid User';
							    	break;
							  default:
							    	console.log("Error changing password:", error);
									$scope.errorMessage = 'Unable to update password.';
							}
					  } else {
					    	console.log("User password changed successfully!");
					  		$scope.successMessage = 'Password successfully updated.';
					  }
					});
				};
			}
		};

	});

})();
